module.exports = __webpack_public_path__ + "img/115014.9206332d.png";